import { IssueFieldConfig } from '@fb/models/issues-type.model';
import { environment } from '@fb/environments';

const isEvnTWU = environment.shortName === 'tw';

export const FIELDS_CONFIG: Record<string, IssueFieldConfig[]> = {
  'Standart Hardware': [
    {
      fieldId: 'customfield_23351',
      allowedValues: ['Laptop/PC', 'Additional Hardware', 'Accessories'],
      isRequired: true,
    },
    {
      fieldId: 'customfield_23352',
      parent: {
        fieldId: 'customfield_23351',
        values: {
          'Laptop/PC': ['Windows', 'MacOS', 'Linux'],
        },
      },
      isRequired: true,
    },
    {
      fieldId: 'customfield_23353',
      parent: {
        fieldId: 'customfield_23351',
        values: {
          'Additional Hardware': ['Monitor', 'Graphic Tablet'],
          Accessories: [
            'Cable (for charger, monitor or tec)',
            'Adaper',
            'Charger',
            'Mouse',
            'Keyboard',
            'Headphones',
            'Other',
          ],
        },
      },
      isRequired: true,
    },
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
  'Service Request': [
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
  Hardware: [
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
  Software: [
    {
      fieldId: 'customfield_20378',
      allowedValues: ['Install', 'Uninstall', 'Update'],
    },
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
  'Non-Standard Hardware': [
    {
      fieldId: 'customfield_23351',
      allowedValues: [
        'Laptop/PC',
        'Additional hardware or accessories',
        'Ecoflow',
      ],
      isRequired: true,
    },
    {
      fieldId: 'customfield_23352',
      parent: {
        fieldId: 'customfield_23351',
        values: {
          'Laptop/PC': ['Windows', 'MacOS', 'Linux'],
        },
      },
      isRequired: true,
    },
    {
      fieldId: 'customfield_23357',
      parent: {
        fieldId: 'customfield_23351',
        values: {
          'Additional hardware or accessories': ['Spesify vendor, model, link'],
        },
      },
      isRequired: true,
    },
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
  'CS Service request': [
    { fieldId: 'customfield_23602' },
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
  'CS Hardware': [
    {
      fieldId: 'customfield_23351',
      allowedValues: [
        'Laptop/PC',
        'Additional Hardware',
        'Accessories',
        ...(!isEvnTWU ? ['Additional hardware or accessories', 'Ecoflow'] : []),
      ],
    },
    {
      fieldId: 'customfield_23352',
      parent: {
        fieldId: 'customfield_23351',
        values: {
          'Laptop/PC': ['Windows', 'MacOS', 'Linux'],
        },
      },
    },
    {
      fieldId: 'customfield_23353',
      parent: {
        fieldId: 'customfield_23351',
        values: {
          ...(isEvnTWU
            ? {
                'Laptop/PC': ['Laptop', 'PC'],
              }
            : {}),
          'Additional Hardware': isEvnTWU
            ? ['Monitor']
            : ['Monitor', 'Graphic Tablet'],
          Accessories: [
            'Cable (for charger, monitor or tec)',
            'Adaper',
            'Charger',
            'Mouse',
            'Keyboard',
            'Headphones',
            'Other',
          ],
          'Additional hardware or accessories': ['Spesify vendor, model, link'],
        },
      },
    },
    {
      fieldId: 'summary',
    },
    {
      fieldId: 'description',
      isRequired: true,
    },
  ],
};
